import { render } from "./Index.vue?vue&type=template&id=38260efe"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=38260efe&lang=css"
script.render = render

export default script